import { jsx } from "react/jsx-runtime";
import {
  SimpleSelect as BaseSimpleSelect
} from "@workwave-tidal/core/components";
import { useFormFairyBridge } from "../../hooks/useFormFairyBridge.js";
function SimpleSelect(props) {
  const {
    options,
    clearable,
    selectProps,
    renderValue,
    renderOptions,
    inputLabelProps,
    formControlProps,
    ...bridgeOptions
  } = props;
  const {
    config: { fullWidth, label, name, testId = "select-root" },
    fieldInfo: {
      field: { required, visible },
      value,
      onBlur,
      onFocus,
      onChange,
      fieldDisabled,
      fieldHasError,
      showErrorAccent,
      errorOrHelperText
    }
  } = useFormFairyBridge(bridgeOptions);
  const handleOnChange = (event) => {
    onChange(event.target.value);
  };
  const handleOnClear = () => {
    if (selectProps?.onClear) {
      selectProps?.onClear();
    } else {
      onChange("");
    }
  };
  const onClear = clearable ? handleOnClear : void 0;
  if (!visible) return null;
  return /* @__PURE__ */ jsx(
    BaseSimpleSelect,
    {
      onClear,
      componentsProps: {
        root: formControlProps,
        label: inputLabelProps
      },
      ...selectProps,
      name,
      label,
      error: showErrorAccent && fieldHasError,
      value,
      onBlur,
      testId,
      onFocus,
      options,
      disabled: fieldDisabled,
      onChange: handleOnChange,
      required,
      fullWidth,
      helperText: errorOrHelperText,
      renderValue,
      renderOptions
    }
  );
}
export {
  SimpleSelect
};
//# sourceMappingURL=SimpleSelect.js.map
